import { render, staticRenderFns } from "./ModifierGroups.vue?vue&type=template&id=2cc98094&"
import script from "./ModifierGroups.vue?vue&type=script&lang=js&"
export * from "./ModifierGroups.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports